import { Link } from 'react-router-dom';

interface FanArtCardProps {
  post: {
    id: string;
    title: string;
    image_url: string | null;
    author: {
      id: string;
      username: string;
      avatar_url: string | null;
    };
    like_count: number;
  };
  onClick: () => void;
}

const FALLBACK_IMAGE = 'https://public.readdy.ai/ai/img_res/795988e04770d5cbd0ea26f6323a8673.jpg';

export default function FanArtCard({ post, onClick }: FanArtCardProps) {
  const imageUrl = post.image_url || FALLBACK_IMAGE;

  return (
    <div 
      className="bg-zinc-900/50 border border-red-900/20 hover:border-red-900/40 transition-all duration-300 group cursor-pointer overflow-hidden"
      onClick={onClick}
    >
      {/* Image */}
      <div className="aspect-square overflow-hidden bg-zinc-900">
        <img
          src={imageUrl}
          alt={post.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            if (target.src !== FALLBACK_IMAGE) {
              target.src = FALLBACK_IMAGE;
            }
          }}
        />
      </div>

      {/* Info */}
      <div className="p-4">
        <h3 className="text-base font-['Cinzel'] text-zinc-100 mb-3 group-hover:text-red-400 transition-colors line-clamp-2">
          {post.title}
        </h3>

        <div className="flex items-center justify-between">
          {/* Author */}
          <Link
            to={`/profile/writer/${post.author.id}`}
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
            onClick={(e) => e.stopPropagation()}
          >
            {post.author.avatar_url ? (
              <img
                src={post.author.avatar_url}
                alt={post.author.username}
                className="w-8 h-8 rounded-full object-cover border border-red-900/30"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-red-900/20 border border-red-900/30 flex items-center justify-center">
                <i className="ri-user-line text-red-500 text-sm"></i>
              </div>
            )}
            <span className="text-sm text-red-400 font-['Crimson_Text']">
              {post.author.username}
            </span>
          </Link>

          {/* Like Count */}
          <div className="flex items-center gap-1.5 text-zinc-500">
            <i className="ri-heart-line text-base"></i>
            <span className="text-sm font-['Crimson_Text']">{post.like_count}</span>
          </div>
        </div>
      </div>
    </div>
  );
}